export const VOUCHER_DUPLICATE_START = "VOUCHER_DUPLICATE_START";
export const VOUCHER_DUPLICATE_SUCCESS = "VOUCHER_DUPLICATE_SUCCESS";
export const VOUCHER_DUPLICATE_ERROR = "VOUCHER_DUPLICATE_ERROR";
export const GET_VOUCHER_DUPLICATE = "GET_VOUCHER_DUPLICATE";
export const CLEAR_DUPLICATE_VOUCHER = "CLEAR_DUPLICATE_VOUCHER";
